module.exports = __webpack_public_path__ + "static/media/lang.f5693a22.svg";